import { useQuery } from '@tanstack/react-query'

import endpoints from 'endpoints.json'
import axios from 'utils/network'

const MOMENT_DETAIL_QUERY_KEY = (momentHashid: string) => ['momentDetail', momentHashid]

export function useMomentDetailQuery(momentHashid: string) {
    return useQuery(
        MOMENT_DETAIL_QUERY_KEY(momentHashid),
        () => axios.get<StandaloneMoment>(`${endpoints.momentList}${momentHashid}`).then((res) => res.data),
        // Handle edge cases where the (probably same) user clicks on Share and visits the link immediately, before the
        // audio had a chance to be truncated properly.
        { refetchInterval: (data) => (!data || data.audio_file_presigned_url ? false : 3000) }
    )
}
